import { TypographyP2 } from '@heidi/design-system/typography';
import type { ReactNode } from 'react';

import { ChangeScrollPanel } from './change-scroll-panel';
import { removalTintClassName } from './change-tint';

export interface DraftApprovalBodyRenderArgs {
  body: string;
  isStreaming: boolean;
  /** Text to tint `body` against: words it adds are tinted, removals hidden. */
  tintAgainst?: string;
  /** The whole body is text this edit removes. */
  removal?: boolean;
}

export interface DraftBodyProps extends DraftApprovalBodyRenderArgs {
  /** Host-supplied note preview (TipTap). Falls back to preformatted text. */
  renderBody?: (args: DraftApprovalBodyRenderArgs) => ReactNode;
}

/**
 * The text a session edit leaves, in a scroll panel that follows the end while
 * it streams. Pair it with `useDraftPreview`, which works out the text and what
 * to tint it against.
 */
export const DraftBody = ({ renderBody, ...args }: DraftBodyProps) => (
  <div data-testid="draft-approval-body">
    <ChangeScrollPanel
      surface="surface"
      scrollClassName="max-h-96"
      followEnd={args.isStreaming}
      testIdPrefix="draft-approval-body"
    >
      {renderBody ? (
        renderBody(args)
      ) : (
        <TypographyP2
          className={
            args.removal
              ? `${removalTintClassName} whitespace-pre-wrap`
              : 'whitespace-pre-wrap text-pretty text-text-primary'
          }
        >
          {args.body}
        </TypographyP2>
      )}
    </ChangeScrollPanel>
  </div>
);
